import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';
import { EllipsisVerticalIcon } from '@heroicons/react/20/solid';
import { EllipsisHorizontalIcon } from '@heroicons/react/24/outline/index.js';
import TrashIcon from './icons/TrashIcon.jsx';
import DropdownButton from './DropdownButton.jsx';

function classNames(...classes) {
    return classes.filter(Boolean).join(' ');
}
type Option = {
    name: string;
    icon?: React.JSX.Element;
    onClick?: Function;
    description?: string;
    isDelete?: boolean;
};
type DotDotDotMenuProps = {
    options: Array<Option>;
    btnClassName?: string;
    menuItemsClassName?: string;
    btnContent?: any,
};
const DotDotDotMenu = ({
    options,
    btnClassName,
    menuItemsClassName,
    btnContent,
}: DotDotDotMenuProps) => {
    return (
        <DropdownButton
            options={options}
            menuItemsClassName={`z-[9999] ${menuItemsClassName || ''}`}
            btnClassName={`${btnClassName ? btnClassName : 'flex items-center rounded-full text-gray-400 hover:text-gray-600 focus:outline-none'}`}
            btnContent={
                btnContent ? btnContent : (
                    <EllipsisHorizontalIcon
                        className="h-5 w-5"
                        aria-hidden="true"
                    />
                )
            }
        />
    );
};

export default DotDotDotMenu;
